import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { ApiUrls } from './app/common/api-urls';
import { Common } from './app/common/common';
import { LoginResponseV2 } from './app/models/auth/login-response';
import { ResponseModel } from './app/models/response-model';
import { environment } from './environments/environment';


function fetchHttpOnlyCookie(): Promise<ResponseModel<LoginResponseV2>> {
  return new Promise((resolve, reject) => {
    // Simulating an API call
    const url = ApiUrls.gethttpcookie + "?cookiekey=SessionId&readAll=" + false;
    fetch(url, {
      method: 'GET',
      credentials: 'include', // Include cookies
      headers : {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
        'Access-Control-Allow-Credentials': 'true',
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
        Expires: '0'
      }
    })
      .then((response) => {
        if (!response.ok) {
          reject("Failed to fetch cookies");
        }
        return response.json();
      })
      .then((data) => {
        resolve(data); // Data from API
      })
      .catch((error) => reject(error));
  });
}

function initializeApp() {
  if (environment.production) {
    enableProdMode();
  }

  fetchHttpOnlyCookie()
    .then((responseData) => {
      const getcookieRequestVM = responseData.data;
      if(getcookieRequestVM){
        if (!Common.loginResponseModel) {
          Common.loginResponseModel = getcookieRequestVM;
        }
      }

      platformBrowserDynamic().bootstrapModule(AppModule)
      .catch(err => console.error(err));
    })
    .catch((error) => {
      console.error("Error fetching cookies:", error);
    });
}

// Initialize the application
initializeApp();

